module.exports = __webpack_public_path__ + "static/media/OutliersMCQ3_5.12c3d5c8.svg";